var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextcar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28253",
    "data-name": "\\uC0AC\\uAC01\\uD615 28253",
    width: 18.865,
    height: 11.317,
    transform: "translate(0 0)",
    fill: "#343a40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21869",
    "data-name": "\\uADF8\\uB8F9 21869",
    transform: "translate(-1390 -417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28252",
    "data-name": "\\uC0AC\\uAC01\\uD615 28252",
    width: 24,
    height: 24,
    transform: "translate(1390 417)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21868",
    "data-name": "\\uADF8\\uB8F9 21868",
    transform: "translate(1392.567 423.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21867",
    "data-name": "\\uADF8\\uB8F9 21867",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10318",
    "data-name": "\\uD328\\uC2A4 10318",
    d: "M10.8,15.09H.857a.885.885,0,0,1,0-1.768H10.8a.885.885,0,0,1,0,1.768",
    transform: "translate(0 -8.596)",
    fill: "#343a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10319",
    "data-name": "\\uD328\\uC2A4 10319",
    d: "M34.667,11.316a.843.843,0,0,1-.638-.293.9.9,0,0,1,.065-1.249l4.447-4.116L34.094,1.541A.9.9,0,0,1,34.029.293a.839.839,0,0,1,1.21-.067L40.4,5a.9.9,0,0,1,0,1.316L35.239,11.09a.838.838,0,0,1-.572.226",
    transform: "translate(-21.816 0)",
    fill: "#343a40"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextcar);
export default __webpack_public_path__ + "static/media/Nextcar.90aa9d2a8ab05f71e92441a73ceb65c8.svg";
export { ForwardRef as ReactComponent };